export const NOTIFICATION_MODAL = 'notificationModal';
export const CREATE_REPORT_MODAL = 'createReportModal';
export const TEMPLATES_MODAL = 'templatesModal';
export const COMPANY_SWITCH_MODAL = 'companySwitchModal';
export const CONFIRM_MODAL = 'confirmModal';

export const MODAL_TYPES = {
	NOTIFICATION_MODAL,
	CREATE_REPORT_MODAL,
	TEMPLATES_MODAL,
	COMPANY_SWITCH_MODAL,
	CONFIRM_MODAL,
} as const;

export const DEFAULT_AUTOCLOSE_DELAY = 5000;
